import { useEffect, useState } from "react";
import { getRuntime } from "@next-core/runtime";
export function useNavConfig() {
  const [navConfig, setNavConfig] = useState(() => getRuntime().getNavConfig());
  useEffect(() => {
    const listener = event => {
      setNavConfig(event.detail);
    };
    window.addEventListener("navConfig.change", listener);
    return () => window.removeEventListener("navConfig.change", listener);
  }, []);
  return navConfig;
}
//# sourceMappingURL=useNavConfig.js.map